export default "__VITE_ASSET__B7L9q0Rs__"